import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailmergeAdminViewerComponent } from './mailmerge-admin-viewer.component';
import { TextViewerModule } from '../../text-viewer/index';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [MailmergeAdminViewerComponent],
  imports: [
    CommonModule,
    TextViewerModule,
    FormsModule,
  ],
  exports: [
    MailmergeAdminViewerComponent,
    CommonModule,
    TextViewerModule,
    FormsModule,
  ],
})
export class MailmergeAdminViewerModule { }
